/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Utils')
    .factory('DateTools', ['$filter', function ($filter) {
        // milliseconds per day
        var DAYS_CONVERTION_INDEX = 1000 * 60 * 60 * 24;

        return {
            formatDate: function(dateInfo, includeHours) {
                return $filter('date')(new Date(dateInfo), 'yyyy-MM-dd' + (includeHours ? ' HH:mm:ss' : ''));
            },

            // gets the start date string and the number of days to add and returns the new date
            addDays: function(startDate, days) {
                return new Date(this.parseDate(startDate) + this.daysToMilliseconds(days));
            },

            // gets the date string and returns the number of days that passed since then
            daysSince: function(since) {
                return this.millisecondsToDays(this.dateNow() - this.parseDate(since))
            },

            dateNow: function(dateString) {
                return Date.now();
            },

            parseDate: function(dateString) {
                return Date.parse(dateString);
            },

            millisecondsToDays: function(milliseconds) {
                return Math.floor(milliseconds / DAYS_CONVERTION_INDEX);
            },

            daysToMilliseconds: function(days) {
                return days * DAYS_CONVERTION_INDEX;
            },

            addZero: function(i) {
                if (i < 10) {
                    i = "0" + i;
                }
                return i;
            }
        }
    }]);
 
 
